// src/stores/warehouseStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WarehouseStore {
  selectedWarehouseId: string;
  selectedWarehouseName: string;
  selectedWarehouseAddress: string;
  selectedWarehouseGstin: string;
  selectedWarehouseState: string;
  setSelectedWarehouse: (id: string, name: string, gstin?: string, state?: string, address?: string) => void;
}

export const useWarehouseStore = create<WarehouseStore>()(
  persist(
    (set) => ({
      selectedWarehouseId: '',
      selectedWarehouseName: '',
      selectedWarehouseAddress: '',
      selectedWarehouseGstin: '',
      selectedWarehouseState: '',
      setSelectedWarehouse: (id, name, gstin = '', state = '', address = '') =>
        set({
          selectedWarehouseId: id,
          selectedWarehouseName: name,
          selectedWarehouseGstin: gstin,
          selectedWarehouseState: state,
          selectedWarehouseAddress: address,
        }),
    }),
    { name: 'selected-warehouse' }
  )
);